import styled from 'styled-components'

import { theme } from 'lib/styleUtils'

const IconLeft = styled.div`
  display: flex;
  position: absolute;
  left: ${theme('spacing.s')};
  top: 50%;
  transform: translateY(-50%);
`

export default IconLeft
